/* lua.js generated code 0.3.0 */

var FishMoveContainer = xClass("FishMoveContainer", cc.Node)
var Move_Time = 1
FishMoveContainer.create = function (gameItemData) {
    var self = this
    // body
    var s = FishMoveContainer.new()
    s.init(gameItemData)
    return s
}
FishMoveContainer.prototype.init = function (gameItemData) {
    var self = this
    // body
    self.setCascadeOpacityEnabled(true)
    self.itemData = gameItemData
    self.boardData = GameBoardData.new()
}
FishMoveContainer.prototype.playMoveList = function (delegate, moveList, callback, isProduce, boardView) {
    var self = this
    // body
    let sp = delegate.createTransClippingSprite(self.itemData, self.boardData)
    self.sp = sp
    self.addChild(sp)
    sp.setCascadeOpacityEnabled(true)
    let $st8 = sp.getChildren()
    for (let k in $st8) {
        let v = $st8[k]
        if ($null(v)) continue
        v.setCascadeOpacityEnabled(true)
    }
    self.trasnContainer = sp
    let actionList = table()
    self.delegate = delegate
    let $limit12 = $len(moveList)
    for (let k = 1; k <= $limit12; k += 1) {
        let v = moveList[k]
        if (v.moveType === FishMoveType.kStart) {
            let pos = delegate.getBasePosition(v.c, v.r)
            self.setPosition(pos.x, pos.y)
            if (v.isHideDisplay) {
                self.setVisible(false)
            }
        } else if (v.moveType === FishMoveType.kRecycleEnd) {
            let pos_to = delegate.getBasePosition(v.c, v.r)
            function update() {
                let __VA_ARG = $slice(arguments, 0)
                // body
                self.addFakeDisappearView(v, delegate)
                self.setPosition(pos_to)
                self.setVisible(false)
                let [pre_r, pre_c] = [v.pre_r, v.pre_c]
                cc.log(pre_r, pre_c)
                if (pre_r && pre_c) {
                    let pre_view = boardView.baseMap[pre_r][pre_c]
                    pre_view.playLoutsWaves(v.roadDir_pre)
                }
            }
            table.insert(actionList, cc.CallFunc.create(update))
            let actionAppear = self.getAppearAction(v.roadDir, pos_to.x, pos_to.y, GamePlayConfig_Fish_Move_Time_Scale)
            table.insert(actionList, actionAppear)
        } else if (v.moveType === FishMoveType.kShow) {
            let {x: px, y: py} = self.getPosition()
            table.insert(actionList, self.getAppearAction(v.roadDir, px, py, isProduce && GamePlayConfig_Fish_Produce_Time_Scale || GamePlayConfig_Fish_Move_Time_Scale))
        } else if (v.moveType === FishMoveType.kMove || v.moveType === FishMoveType.kEnd) {
            self.addMoveActionList(v, actionList, delegate, moveList, isProduce, boardView)
        } else if (v.moveType === FishMoveType.kWait) {
            let time_scale = isProduce && GamePlayConfig_Fish_Produce_Time_Scale || GamePlayConfig_Fish_Move_Time_Scale
            table.insert(actionList, cc.DelayTime.create(Move_Time * time_scale))
        }
    }
    table.insert(actionList, cc.CallFunc.create(callback))
    self.runAction(cc.Sequence.create(actionList))
}
FishMoveContainer.prototype.addFakeDisappearView = function (moveData, delegate) {
    var self = this
    // body
    var sp = delegate.createTransClippingSprite(self.itemData, self.boardData)
    self.getParent().addChild(sp)
    // var {x, y} = self.getPosition()
    var x = self.getPosition().x
    var y = self.getPosition().y
    sp.setPosition(x, y)
    sp.setCascadeOpacityEnabled(true)
    var $st28 = sp.getChildren()
    for (var k in $st28) {
        var v = $st28[k]
        v.setCascadeOpacityEnabled(true)
    }
    var action_fake = table()
    function playAnimation() {
        var __VA_ARG = $slice(arguments, 0)
        // body
    }
    table.insert(action_fake, cc.CallFunc.create(playAnimation))
    var times = GamePlayConfig_Fish_Move_Time_Scale * Move_Time
    var toPos = delegate.getBasePosition(moveData.recycleEnd.c, moveData.recycleEnd.r)
    var fromPos = cc.p(x, y)
    table.insert(action_fake, self.getDisappearAction(moveData.roadDir_pre, fromPos, toPos, GamePlayConfig_Fish_Move_Time_Scale))
    table.insert(action_fake, cc.RemoveSelf.create(true))
    sp.runAction(cc.Sequence.create(action_fake))
}
FishMoveContainer.prototype.getAppearAction = function (dir, offsetx, offsety, timeScale) {
    var self = this
    var time_scale = GamePlayConfig_Fish_Produce_Time_Scale || GamePlayConfig_Fish_Move_Time_Scale //isProduce && GamePlayConfig_Fish_Produce_Time_Scale || GamePlayConfig_Fish_Move_Time_Scale //
    var time1 = Move_Time * time_scale
    var action = cc.Sequence.create(cc.CallFunc.create(function (target) {
        // body
        target.setVisible(true)
        let offsetK = table([1, "x", 0], [1, "y", 0])
        if (dir == GameItemDirection.kRight) {
            offsetK.x = 1
        } else if (dir == GameItemDirection.kLeft) {
            offsetK.x = -1
        } else if (dir == GameItemDirection.kUp) {
            offsetK.y = 1
        } else if (dir == GameItemDirection.kDown) {
            offsetK.y = -1
        }
        target.setPosition(offsetx, offsety)
        var count = 0
        var contianer = target.trasnContainer
        if (contianer) {
            var $st39 = contianer.getChildren()
            for (var k in $st39) {
                var v = $st39[k]
                v.setOpacity(0)
                v.setScale(0.3)
                v.setCascadeOpacityEnabled(true)
                count = count + 1
                v.setPosition(v.getPositionX() - 30 * offsetK.x, v.getPositionY() - 30 * offsetK.y)
                v.runAction(cc.Sequence.create(cc.DelayTime.create((k - 1) / 15), cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(8 / 13 * time1, 1, 1), cc.MoveBy.create(8 / 13 * time1, cc.p(33 * offsetK.x, 33 * offsetK.y)), cc.FadeTo.create(8 / 13 * time1, 255))), cc.EaseSineOut.create(cc.MoveBy.create(5 / 13 * time1, cc.p(-3 * offsetK.x, -3 * offsetK.y)))))
            }
        }
    }), cc.DelayTime.create(time1))
    return action
}
FishMoveContainer.prototype.getDisappearAction = function (dir, fromPos, toPos, timeScale) {
    var self = this
    var time_scale =  GamePlayConfig_Fish_Produce_Time_Scale || GamePlayConfig_Fish_Move_Time_Scale //isProduce &&
    var time1 = Move_Time * time_scale
    var time = 9 / 30
    var action = cc.Sequence.create(cc.CallFunc.create(function (target) {
        // body
        target.setPosition(fromPos.x, fromPos.y)
        target.setOpacity(255)
        target.setScale(1)
        var $st46 = target.getChildren()
        for (var k in $st46) {
            var v = $st46[k]
            var move = cc.EaseSineOut.create(cc.Spawn.create(cc.MoveBy.create(time, cc.p(toPos.x - fromPos.x, toPos.y - fromPos.y)), cc.ScaleTo.create(time, 0.5), cc.FadeTo.create(time, 0)))
            v.runAction(cc.Sequence.create(cc.DelayTime.create((k - 1) * 2 / 30), move))
        }
    }), cc.DelayTime.create(time + 0.1))
    return action
}
FishMoveContainer.prototype.addMoveActionList = function (moveData, actionList, delegate, moveList, isProduce, boardView) {
    var self = this
    // body
    var time_scale = isProduce && GamePlayConfig_Fish_Produce_Time_Scale || GamePlayConfig_Fish_Move_Time_Scale
    function playAnimation(target) {
        // body
        if (moveData.isTransMove) {
            self.setVisible(false)
            self.addTransView(moveData, delegate, moveList)
        }
        var [pre_r, pre_c] = [moveData.pre_r, moveData.pre_c]
        if (pre_r && pre_c) {
            var pre_view = boardView.baseMap[pre_r][pre_c]
            pre_view.playLoutsWaves(moveData.roadDir_pre)
        }
    }
    function updateDirection() {
        if (moveData.isTransMove) {
            self.setVisible(true)
            self.removeTransView()
        }
    }
    table.insert(actionList, cc.CallFunc.create(playAnimation))
    var flag = -1
    if (self.direction === GameItemDirection.kLeft) {
        flag = 1
    }
    if (moveData.moveType === FishMoveType.kEnd) {
        var toPos = delegate.getBasePosition(moveData.c, moveData.r)
        var preEnd = null
        for (var _ = 1, mv = moveList[1]; mv; _++, mv = moveList[_]) {
            if (mv.c === moveData.c && mv.r === moveData.r) {
                break
            }
            preEnd = mv
        }
        var fromPos = delegate.getBasePosition(preEnd.c, preEnd.r)
        table.insert(actionList, self.getDisappearAction(moveData.roadDir_pre, fromPos, toPos, time_scale))
    } else {
        var action = cc.MoveTo.create(Move_Time * time_scale, delegate.getBasePosition(moveData.c, moveData.r))
        table.insert(actionList, action)
    }
    table.insert(actionList, cc.CallFunc.create(updateDirection))
}
moveToTrans = function (sp, moveData, isOut, moveList) {
    // body
    var w = GamePlayConfig_Tile_Width
    var h = GamePlayConfig_Tile_Height
    var pos_from, pos_to
    var dir = isOut && moveData.roadDir_pre || moveData.roadDir
    if (isOut) {
        pos_from = cc.p(w / 2, h / 2)
    } else {
        var dirTemp = dir
        if (dirTemp === GameItemDirection.kNone) {
            dirTemp = moveData.roadDir_pre
        }
        if (dirTemp === GameItemDirection.kLeft) {
            pos_from = cc.p(70, 0)
        } else if (dirTemp === GameItemDirection.kRight) {
            pos_from = cc.p(-70, 0)
        } else if (dirTemp === GameItemDirection.kUp) {
            pos_from = cc.p(0, -70)
        } else if (dirTemp === GameItemDirection.kDown) {
            pos_from = cc.p(0, 70)
        } else {
            pos_from = cc.p(70, 0)
        }
        pos_from.x = pos_from.x + w / 2
        pos_from.y = pos_from.y + h / 2
    }
    var pos
    var dirTemp = dir
    if (dirTemp === GameItemDirection.kNone) {
        dirTemp = moveData.roadDir_pre
    }
    if (dirTemp === GameItemDirection.kLeft) {
        pos = cc.p(-70, 0)
    } else if (dirTemp === GameItemDirection.kRight) {
        pos = cc.p(70, 0)
    } else if (dirTemp === GameItemDirection.kUp) {
        pos = cc.p(0, 70)
    } else if (dirTemp === GameItemDirection.kDown) {
        pos = cc.p(0, -70)
    } else {
        pos = cc.p(-70, 0)
    }
    pos_to = cc.p(0, 0)
    pos_to.x = pos_from.x + pos.x
    pos_to.y = pos_from.y + pos.y
    sp.setPosition(pos_from)
    var actionList = table()
    var flag = -1
    if (moveData.dir === GameItemDirection.kLeft) {
        flag = 1
    }
    function playWaves() {
        var __VA_ARG = $slice(arguments, 0)
        // body
    }
    table.insert(actionList, cc.CallFunc.create(playWaves))
    var time_scale = GamePlayConfig_Fish_Move_Time_Scale
    if (moveData.moveType === FishMoveType.kEnd || moveData.moveType === FishMoveType.kRecycleEnd) {
        table.insert(actionList, FishMoveContainer.getDisappearAction(moveData.roadDir_pre, pos_from, pos_to, time_scale))
    } else {
        // table.insert(actionList, he.HeCircleMoveToAction:create(time_scale, pos_to, 15 * flag, 1))
        table.insert(actionList, cc.MoveTo.create(time_scale, pos_to))
    }
    sp.runAction(cc.Sequence.create(actionList))
}
FishMoveContainer.prototype.removeTransView = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    if (self.transIn) {
        self.transIn.removeFromParent(true)
        self.transIn = null
        self.fishIn = null
    }
    if (self.transOut) {
        self.transOut.removeFromParent(true)
        self.transOut = null
        self.fishOut = null
    }
}
FishMoveContainer.prototype.addTransView = function (moveData, delegate, moveList) {
    var self = this
    // body
    var w = GamePlayConfig_Tile_Width
    var h = GamePlayConfig_Tile_Height
    var posOut = cc.p(self.getPosition())
    var parent = self.getParent()
    var transOut = cc.ClippingRectangleNode.create()
    transOut.setClippingRegion(CCRectMake(0, 0, w, h))
    transOut.setPosition(posOut.x - w / 2, posOut.y - h / 2)
    parent.addChild(transOut)
    var spOut = delegate.createTransClippingSprite(self.itemData, self.boardData)
    spOut.setCascadeOpacityEnabled(true)
    transOut.addChild(spOut)
    moveToTrans(spOut, moveData, true, moveList)
    self.transOut = transOut
    self.spOut = spOut
    var [r, c] = [moveData.r, moveData.c]
    var posIn = delegate.getBasePosition(c, r)
    var transIn = cc.ClippingRectangleNode.create()
    transIn.setClippingRegion(CCRectMake(0, 0, w, h))
    transIn.setPosition(posIn.x - w / 2, posIn.y - h / 2)
    parent.addChild(transIn)
    var spIn = delegate.createTransClippingSprite(self.itemData, self.boardData)
    spIn.setCascadeOpacityEnabled(true)
    transIn.addChild(spIn)
    moveToTrans(spIn, moveData, false, moveList)
    self.transIn = transIn
    self.spIn = spIn
}
FishMoveContainer.createLotusWaves = function (callback) {
    var node = cc.Node.create()
    config = table(
        [0, table(
            [1, "x", 31.65 - 35],
            [1, "y", 35 - 33.9],
            [1, "delay", 0]
        )],
        [0, table(
            [1, "x", 45.4 - 35],
            [1, "y", 35 - 33.55],
            [1, "delay", 5 / 30]
        )],
        [0, table(
            [1, "x", 56.2 - 35],
            [1, "y", 35 - 33.2],
            [1, "delay", 9 / 30]
        )]
    )
    var count = 0
    function _over() {
        var __VA_ARG = $slice(arguments, 0)
        // body
        count = count + 1
        if (count >= 3) {
            // node:removeFromParent(true)
            if (callback) {
                callback()
            }
        }
    }
    for (var k = 1; k <= 3; k += 1) {
        let v = config[k]
        let sp = cc.Sprite.createWithSpriteFrameName("lotus_waves.png")
        sp.setPosition(v.x, v.y)
        sp.setOpacity(0.2 * 255)
        sp.setVisible(false)
        sp.runAction(cc.Sequence.create(cc.DelayTime.create(v.delay), cc.Show.create(), cc.EaseSineIn.create(cc.Spawn.create(cc.MoveBy.create(8 / 30, cc.p(17.8 - 31.65, 0)), cc.FadeTo.create(8 / 30, 255))), cc.EaseSineOut.create(cc.Spawn.create(cc.MoveBy.create(13 / 30, cc.p(5.4 - 17.8, 0)), cc.FadeTo.create(13 / 30, 0.2 * 255), cc.ScaleTo.create(13 / 30, 0.7))), cc.RemoveSelf.create(true), cc.CallFunc.create(_over)))
        node.addChild(sp, 3 - k)
    }
    return node
}
module.exports = FishMoveContainer
